<template>
    <div class="page">
        <div class="content">
            <div class="time_content">
                <div class="date_content" @click="show = true">
                    <span>请选择日期</span>
                    <span>{{ listQuery.start || "暂无" }}</span>
                </div>
                <div>
                    <img src="../assets/bk.png" alt="">
                    <span>{{ day }} 天</span>
                </div>
                <div class="date_content" @click="show = true">
                    <span>请选择日期</span>
                    <span>{{ listQuery.end || "暂无" }}</span>
                </div>
            </div>
            <div class="list_conetnt" v-if="list.length > 0">
                <van-collapse v-model="activeNames">
                    <div class="item" v-for="(item, index) in list" :key="index">
                        <div class="row">
                            <div>充值时间: {{ item.recharge_time }}</div>
                            <div>
                                <van-tag type="success" size="medium" v-if="item.status == 0">待确认</van-tag>
                                <van-tag type="success" size="medium" v-if="item.status == 1">已通过</van-tag>
                            </div>
                        </div>
                        <div class="row">
                            <div>充值金额(元):</div>
                            <div class="num">
                                {{ item.recharge_amount }}
                            </div>
                        </div>
                        <van-collapse-item title="详情" :name="item.id">
                            <div class="row" style="margin-top: 5px;">
                                <div>充值凭证:</div>
                                <div>
                                    <van-image class="pic" :data-src="item.url" fit="fill" :src="item.url" width="60"
                                        height="60" @click="showPreview(item.url)">
                                    </van-image>
                                    <van-image-preview v-model="showImg" :images="icons"></van-image-preview>
                                </div>
                            </div>
                            <div class="row" style="margin-top: 10px;">
                                <div>余额:</div>
                                <div>
                                    {{ Number(item.after_amount).toFixed(2) || "暂无" }}
                                </div>
                            </div>
                        </van-collapse-item>
                    </div>
                </van-collapse>
            </div>
            <div v-else>
                <van-empty description="暂无充值记录！" />
            </div>
        </div>
        <van-calendar v-model="show" type="range" :allow-same-day="true" :min-date="minDate" :max-date="maxDate"
            color="#31b158" @confirm="onConfirm" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeNames: [],
            list: [],
            show: false,
            listQuery: {
                start: "",
                end: ""
            },
            day: "1",
            minDate: new Date(2023, 0, 1), //可选最早时间
            maxDate: new Date(),
            mobile: "",
            list: [],
            access_token: "",
            showImg: false,
            icons: [],
            imgTest: {}
        }
    },
    created() {
        this.mobile = this.getParameterByName("mobile")
        var that = this
        if (!window.sessionStorage.getItem("access_token")) {
            this.$dialog.alert({
                title: "提醒",
                message: '您暂未登录！是否前往登录?',
                showConfirmButton: true,
                showCancelButton: true
            }).then(() => {
                that.$router.push({
                    path: '/Login',
                    query: {
                        mobile: that.mobile
                    }
                });
            }).catch(() => {
                that.$router.push({
                    path: '/index',
                    query: {
                        mobile: that.mobile
                    }
                });
            });
        } else {
            this.access_token = window.sessionStorage.getItem("access_token")
            this.getList()
        }
    },
    mounted() {
        this.pushHistory()
        //  监听popstate事件
        window.addEventListener('popstate', this.listenPopstate);
    },

    beforeDestroy() {
        window.removeEventListener('popstate', this.listenPopstate);
    },
    methods: {
        listenPopstate() {
            if (this.$route.path === '/RechargeList') {
                this.$router.push({
                    path: '/index',
                    query: {
                        mobile: this.mobile
                    }
                });
            }
            //  跳转小程序页面相关逻辑
        },
        pushHistory() {
            window.history.pushState(null, null, null)
        },
        showPreview(url) {
            this.icons.push(url);
            this.showImg = true;
        },
        // 解析URL
        getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            //匹配所有符合条件的，并取最后一个
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", 'g');
            var results = url.match(regex);
            var tempResults = results != null && results[results.length - 1] != undefined ? results[results.length - 1] : '';
            var finalResults = regex.exec(tempResults);
            if (!finalResults) return "";
            if (!finalResults[2]) return '';
            return decodeURIComponent(finalResults[2].replace(/\+/g, " "));
        },
        formatDate(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        },
        onConfirm(date) {
            const [start, end] = date;
            this.show = false;
            this.day = (new Date(date[1]).getTime() - new Date(date[0]).getTime()) / (1 * 1000 * 60 * 60 * 24) + 1
            this.listQuery.start = this.formatDate(start);
            this.listQuery.end = this.formatDate(end);
            this.getList()
        },
        async getList() {
            const { data: res } = await this.$https.post('/mobileh5/order/recharge-list?access_token=' + window.sessionStorage.getItem("access_token"), this.listQuery, { timeout: 2000 })
            if (res.resultCode == "1") {
                this.list = res.resultInfo
            }
        }
    },
}
</script>

<style lang="less" scoped>
[v-cloak] {
    display: none
}

.page {
    background-color: #f1f4f9;
    user-select: none;
    width: 100%;
    height: 100vh;
}

.content {
    height: 100vh;
    width: 100%;
    overflow-y: auto;
}

.time_content {
    width: 100%;
    height: 52px;
    background-color: #fff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;

    >div {
        flex: 1;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }

    >div:nth-child(2) {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        font-size: 12px;
        color: #9ea5b8;

        img {
            width: 100%;
            height: 23px;
        }

        span {
            position: absolute;
        }
    }
}

.date_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #000;
    font-size: 15px;

    >span:nth-child(1) {
        color: #9ea5b8;
        font-size: 13px;
    }
}

.list_conetnt {
    width: 100%;
    height: calc(100vh - 60px);
    margin-top: 8px;
    box-sizing: border-box;
    padding: 0 10px;

    .item {
        background-color: #fff;
        width: 100%;
        // height: 160px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 8px;
        margin-bottom: 10px;

        .row {
            width: 100%;
            height: 44px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
}

/deep/ .van-cell {
    width: 100%;
    height: 44px;
    line-height: 44px;
    padding: 0 !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
}

.num {
    font-weight: 600;
    font-style: 18px;
    color: #31b158;
}
</style>